import { ApiEndPoint } from '@/domains/api/api.entity';
import { apiRequest } from './apiRequest';

/**
 * Servicio API para operaciones de logout
 * Maneja la invalidación del token en el servidor
 */
class LogoutApiService {
  async logout(): Promise<void> {
    try {
      // Llamada al endpoint de logout para invalidar token en servidor
      await apiRequest.post<void, {}>({
        route: ApiEndPoint.LOGOUT,
        payload: {},
      });
    } catch (error) {
      // Log el error pero no bloquear el logout local
      console.warn('Error al invalidar token en servidor:', error);
      // El logout local debe continuar incluso si falla el servidor
    }
  }
}

export const logoutApiService = new LogoutApiService();
